<template>
  <section class="calculator" :class="{ print: printing }">
    <div v-if="!printing">
      <div class="wrap">
        <h1>Jämför drivmedelspriser</h1>
      </div>
    </div>
    <div class="wrap" v-if="companies.length > 0 && !printing">
      <div class="contain-rows">
        <div class="row">
          <div class="first-entry">
            <div class="container">
              Drivmedelstyp
            </div>
          </div>
          <div class="target">
            <div class="container">
              Bensin
              <div class="radio-toolbar">
                <input id="gas" type="radio" name="type" value="gasPrice" v-model="type" />
                <label for="gas"></label>
              </div>
            </div>
          </div>
          <div class="target">
            <div class="container">
              Diesel
              <div class="radio-toolbar">
                <input id="diesel" type="radio" name="type" value="dieselPrice" v-model="type" />
                <label for="diesel"></label>
              </div>
            </div>
          </div>
        </div>
        <div class="row mobile-only mobile-header">
          <div class="first-entry">
            Välj ett bolag för jämförelse
          </div>
          <div class="column-wrap">
            <div class="columns checkbox-toolbar">
              <div class="column" v-for="company in companies" v-if="company.name !== 'Tanka'" :key="company.name">
                <div class="image-container">
                  <template v-if="company.name !== 'Other'">
                    <a :href="company.website" target="_blank" class="letter-spacing">
                      <img :src="company.logotype" />
                    </a>
                  </template>
                  <template v-else>
                    <img :src="company.logotype" />
                  </template>
                </div>
                <div class="checkbox" v-on:click.prevent="fixateOnlyThisTarget(company.name)" v-on:touchstart.prevent="fixateOnlyThisTarget(company.name)" :class="[ chosenCompanies.includes(company.name) ? 'checked' : '' ]"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="first-entry">
            <div class="container no-mobile">
              Välj två eller fler för att jämföra
            </div>
          </div>
          <div class="column" v-for="company in companies" :class="{ 'mobile-only-no-display': !chosenCompanies.includes(company.name) }" :key="company.name">
            <div class="container checkbox-toolbar" :style="{ background: chosenCompanies.includes(company.name) ? '' : 'transparent' }">
              <div class="added-margin-top no-mobile">
                <div class="checkbox" v-on:click.prevent="fixateTarget(company.name)" v-on:touchstart.prevent="fixateTarget(company.name)" :class="[ chosenCompanies.includes(company.name) ? 'checked' : '' ]"></div>
              </div>
              <div class="logo-container">
                <template v-if="company.name !== 'Other'">
                  <a :href="company.website" target="_blank" class="letter-spacing">
                    <img :src="company.logotype" />
                  </a>
                </template>
                <template v-else>
                  <img :src="company.logotype" />
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="first-entry">
            <transition>
              <div class="info" v-if="showListPris">
                Listpris är ett förutbestämt pris som gäller för företagskunder. Alla ev. rabatter dras från listpriset.
              </div>
            </transition>
            <div class="container question" v-on:click="showListPris = !showListPris" v-on:mouseover="showListPris = true" v-on:mouseleave="showListPris = false">
              Listpris kr/liter
              <icon name="question-circle" class="icon"></icon>
            </div>
          </div>
          <div class="column" v-for="company in companies" :class="{ 'mobile-only-no-display': !chosenCompanies.includes(company.name) }" :key="company.name">
            <div class="container" :style="{ background: chosenCompanies.includes(company.name) ? '' : 'transparent' }">
              <div class="input-replacement">
                {{ company.data[type + 'List'] | normalize }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="first-entry">
            <div class="container">
              Skyltat pris kr/liter
            </div>
          </div>
          <div class="column" v-for="company in companies" :class="{ 'mobile-only-no-display': !chosenCompanies.includes(company.name) }" :key="company.name">
            <div class="container" :style="{ background: chosenCompanies.includes(company.name) ? '' : 'transparent' }">
              <input type="number" :value="convertPrice(company.data[type])" step="0.01" v-on:change="$emit('updatePrice', $event, company.name, type)" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="first-entry">
            <div class="container">
              Kortrabatt öre/liter
            </div>
          </div>
          <div class="column" v-for="company in companies" :class="{ 'mobile-only-no-display': !chosenCompanies.includes(company.name) }" :key="company.name">
            <div class="container" :style="{ background: chosenCompanies.includes(company.name) ? '' : 'transparent' }">
              <input type="text" :value="convertDiscount(company.data.cardDiscount)" maxlength="3" v-on:keyup="$emit('updateDiscount', $event.target.value, 'cardDiscount', company.name)" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="first-entry">
            <div class="container">
              Fakturarabatt öre/liter
            </div>
          </div>
          <div class="column" v-for="company in companies" :class="{ 'mobile-only-no-display': !chosenCompanies.includes(company.name) }" :key="company.name">
            <div class="container" :style="{ background: chosenCompanies.includes(company.name) ? '' : 'transparent' }">
              <input type="text" :value="convertDiscount(company.data.invoiceDiscount)" maxlength="3" v-on:keyup="$emit('updateDiscount', $event.target.value, 'invoiceDiscount', company.name)" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="first-entry">
            <div class="container">
              Besparing öre/liter
            </div>
          </div>
          <div class="column" v-for="company in companies" :class="{ 'mobile-only-no-display': !chosenCompanies.includes(company.name) }" :key="company.name">
            <div class="container" :style="{ background: chosenCompanies.includes(company.name) ? '' : 'transparent' }">
              <div class="input-replacement">
                {{ calculatedDiscounts(company.name) }}
              </div>
            </div>
          </div>
        </div>
        <div class="row spacing"></div>
        <div class="row">
          <div class="first-entry">
            <div class="container endprice-modifier">
              Slutpris/liter
            </div>
          </div>
          <div class="result-column" v-for="company in companies" :class="{ 'mobile-only-no-display': !chosenCompanies.includes(company.name) }" :key="company.name">
            <div class="container">
              {{ calculateTotal(company.name) | normalize }}
            </div>
          </div>
        </div>
        <div class="button-row" v-if="target">
          <div class="button" v-on:click="scrollDown">Resultat av jämförelse</div>
        </div>
      </div>
    </div>
    <div class="wrap print" v-else>
      <div class="row">
        <div class="chosenType">Vald drivmedelstyp:</div>
        <template v-if="type === 'dieselPrice'">
          Diesel
        </template>
        <template v-else>
          Bensin
        </template>
      </div>
      <table>
        <tr>
          <th>
            Valda aktörer för jämförelse
          </th>
          <th v-for="company in companies" v-if="chosenCompanies.includes(company.name)" :key="company.name">
            <div :class="{ greyBack: company.name === 'Other' }">
              <img :src="company.logotype" />
            </div>
          </th>
        </tr>
        <tr>
          <td>
            Listpris kr/liter
          </td>
          <td v-for="company in companies" v-if="chosenCompanies.includes(company.name)" :key="company.name">
            {{ company.data[type + 'List'] | normalize }}
          </td>
        </tr>
        <tr>
          <td>
            Skyltat pris kr/liter
          </td>
          <td v-for="company in companies" v-if="chosenCompanies.includes(company.name)" :key="company.name">
            {{ company.data[type] | normalize }}
          </td>
        </tr>
        <tr>
          <td>
            Kortrabatt öre/liter
          </td>
          <td v-for="company in companies" v-if="chosenCompanies.includes(company.name)" :key="company.name">
            {{ convertDiscount(company.data.cardDiscount) }}
          </td>
        </tr>
        <tr>
          <td>
            Fakturarabatt öre/liter
          </td>
          <td v-for="company in companies" v-if="chosenCompanies.includes(company.name)" :key="company.name">
            {{ convertDiscount(company.data.invoiceDiscount) }}
          </td>
        </tr>
        <tr>
          <td>
            Besparing öre/liter
          </td>
          <td v-for="company in companies" v-if="chosenCompanies.includes(company.name)" :key="company.name">
            {{ calculatedDiscounts(company.name) }}
          </td>
        </tr>
        <tr>
          <td>
            Slutpris kr/liter
          </td>
          <td v-for="company in companies" v-if="chosenCompanies.includes(company.name)" :key="company.name">
            {{ calculateTotal(company.name) | normalize }} 5
          </td>
        </tr>
      </table>
      <img class="desktop" v-if="printing" src="~assets/images/screen_desktop.png" />
    </div>
  </section>
</template>

<script>
  import scrollDown from 'lib/scrollDown'
  import sizzle from 'sizzle'
  import wNumb from 'wnumb'
  import 'vue-awesome/icons/question-circle'

  export default {
    props: {
      companies: {
        type: Array
      },
      chosenCompanies: {
        type: Array
      },
      type: {
        type: String
      },
      printing: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        target: null,
        showListPris: false,
        showSkyltatPris: false
      }
    },
    mounted () {
      this.target = sizzle('.result')[0]
    },
    filters: {
      toFixed (value) {
        if (Number(value) === value && value % 1 !== 0) {
          return value.toFixed(2)
        }
        return value
      },
      normalize (value) {
        const formatter = wNumb({
          mark: ',',
          thousand: ' ',
          decimals: 2
        })
        return formatter.to(value)
      }
    },
    methods: {
      setDecimal (el) {
        el.value = parseFloat(el.value).toFixed(2)
      },
      scrollDown () {
        scrollDown(this.target.offsetTop)
      },
      // Calculate total prices
      calculateTotal (company) {
        let val = parseFloat(0)
        this.companies.forEach((x) => {
          if (x.name === company) {
            val = (x.name === 'Tanka' ? x.data[this.type] : x.data[this.type + 'List']) + x.data.invoiceDiscount + x.data.cardDiscount
            // val = x.data[this.type] + x.data.invoiceDiscount + x.data.cardDiscount
          }
        })
        return val
      },
      // Converts discount from decimal to base 10
      convertDiscount (discount) {
        const val = parseInt(discount * 100)
        if (val > 0) {
          return '-' + val
        }

        return val
      },
      convertPrice (price) {
        const val = parseFloat(price)
        if (val > 0) {
          return val.toFixed(2)
        }

        return val
      },
      // Calculate both discounts, and converts to a positive number
      calculatedDiscounts (company) {
        let val = 0
        this.companies.forEach((x) => {
          if (x.name === company) {
            val = x.data.invoiceDiscount + x.data.cardDiscount
          }
        })
        val = this.convertDiscount(window.Math.abs(val))
        if (val !== 0) {
          val = '+' + val
        }

        return val.toString().replace('-', '')
      },
      // Appends or removes a company from chosenCompanies array
      fixateTarget (value) {
        this.$emit('handleCompany', value)
      },
      fixateOnlyThisTarget (value) {
        this.$emit('handleOnlyThisCompany', value)
      }
    },
    watch: {
      type () {
        this.$emit('updateType', this.type)
      }
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss" scoped>
  @import "~styles/sizes.scss";
  @import "~styles/inputs.scss";
  @import "~styles/button.scss";

  section {
    background: #488091;
    width: 100%;
    min-height: 100%;
    padding-bottom: 20px;
    overflow: hidden;
    text-align: center;

    &.print {
      background: transparent;
      padding-bottom: 0;
      min-height: 0;

      height: auto;

      h1 {
        display: none;
      }
    }

    h1 {
      font-family: 'Volvo Sans Medium', sans-serif;
      font-weight: normal;
      color: #fff;
      letter-spacing: 0;
      text-align: left;
      font-size: 3em;
      margin-top: 1em;

      @media screen and (max-width: $large) {
        font-size: 2em;
      }

      @media screen and (max-width: $medium) {
        font-size: 1.5em;
      }
    }

    .wrap {
      max-width: 850px;
      width: 100%;
      display: inline-block;
      margin: 10px 0;
      padding: 0 20px;
      text-align: left;
      position: relative;

      .contain-rows {
        display: inline-block;

        @media screen and (max-width: 800px) {
          width: calc(100% - 40px);
        }
      }

      &.print {
        color: #000;
        min-height: 350px;
        max-width: 568px;
        min-width: 400px;
        width: auto;
        display: inline-block;
        z-index: 1;
        text-align: center;
        padding: 40px 75px 0 75px;

        .row {
          color: #000;
          z-index: 10;
          margin-left: 100px;

          .chosenType {
            font-weight: bold;
            display: inline;
          }
        }

        table {
          z-index: 12;
          font-size: 0.7em;
          border-collapse: collapse;

          tr {
            border-bottom: 1px solid #000;

            th {
              font-weight: normal;
              padding: 5px;
              text-align: left;

              .greyBack {
                background: #616161;
                border-radius: 50px;
                height: 35px;
                width: 35px;

                img {
                  max-width: 50px;
                  transform: scale(0.7);
                  margin-left: -3px;
                  margin-top: 3px;
                }
              }

              img {
                max-width: 40px;
                max-height: 30px;
              }
            }

            td {
              padding: 5px 10px;
            }

            td:first-child, th:first-child {
              text-align: left;
            }

            td:nth-child(n+2) {
              text-align: center;
              // font-weight: bold;
            }

            td:nth-child(2) {
              color: #178394;
            }

            td:first-child, th:first-child {
              padding: 10px 10px 10px 0;
            }
          }

          tr:nth-child(7) {
            border: 0;

            td:first-child {
              font-weight: bold;
            }
          }
        }

        .desktop {
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          height: 380px;
          width: 100%;
        }
      }
    }

    .row {
      text-align: left;
      color: #fff;
      font-size: 1.3em;
      overflow: hidden;
      border-collapse: collapse;
      border-spacing: 0;
      display: table-row;

      @media screen and (max-width: 800px) {
        &:nth-child(1) {
          display: block;
          text-align: center;

          .first-entry, .target {
            display: block;
          }

          .first-entry {
            font-size: 1.3em;
            width: 100%;
          }

          .target {
            float: left;
            width: 50%;
          }
        }
      }

      &.mobile-header {
        display: block;
        text-align: center;

        .first-entry {
          width: 100%;
          margin-top: 20px;
          display: block;
          font-size: 1.3em;
        }

        .column-wrap {
          display: inline-block;
        }

        .columns {
          width: 100%;
          overflow: hidden;

          .column {
            float: left;
            max-width: 25%;

            .image-container {
              height: 60px;
              position: relative;
              padding: 5px;

              img {
                max-width: calc(100% - 10px);
                vertical-align: middle;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }
        }
      }

      @media screen and (max-width: $large) {
        font-size: 1.2em;
      }

      @media screen and (max-width: $medium) {
        font-size: 1em;
      }

      &.spacing {
        height: 20px;
      }

      .first-entry, .column, .target {
        // float: left;
        display: table-cell;
      }

      .first-entry {
        width: 200px;
        vertical-align: middle;
        position: relative;
        cursor: default;

        .info {
          position: absolute;
          width: 200%;
          left: 0;
          transform: translateY(-100%);
          padding: 8px;
          border-radius: 10px;
          background: #488091;
          border: 2px solid #fff;
          font-size: 0.8em;
        }

        .container {
          margin: 10px;
          display: inline-block;

          &.question:hover {
            color: #e3e3e3;
          }

          .fa-icon {
            width: auto;
            height: 20px;
            vertical-align: middle;
          }
        }
      }

      .target {
        .container {
          margin: 0 10px;
          text-align: center;
        }
      }

      .column {
        width: 140px;
        height: 100%;
        overflow: hidden;
        vertical-align: top;

        .container {
          border-left: 2px solid #fff;
          border-right: 2px solid #fff;
          background: rgba(255, 255, 255, 0.3);
          height: 100%;
          text-align: center;
          padding-bottom: 9999px;
          margin: 0 10px -9999px;
          transition: all 0.5s ease;

          .added-margin-top {
            margin-top: 5px;
          }

          .input-replacement {
            margin: 15px 5px;
            padding: 10px 5px;
            text-align: center;
            width: 68px;
            font-size: 1.1em;
            font-family: 'Volvo Sans Regular', sans-serif;
            display: inline-block;
            border: 1px solid #fff;
            background: #a6c2c9;
          }

          input[type=text], input[type=number] {
            margin: 15px 5px;
            text-align: center;
            width: 70px;
            padding: 10px 5px;
            font-size: 1.1em;
            font-family: 'Volvo Sans Regular', sans-serif;
            color: #488091;
            outline: none;
            border: none;

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
              -webkit-appearance: none;
              margin: 0;
            }

            &:disabled {
              background: #ededed;
            }
          }
        }
      }

      .endprice-modifier {
        font-weight: bold;
        letter-spacing: 0.05em;
      }

      .result-column {
        display: table-cell;
        margin-top: 20px;
        text-align: center;
        vertical-align: middle;
        font-size: 1.1em;
        font-weight: bold;

        @media screen and (max-width: 800px) {
          &.no-mobile {
            display: none;
          }
        }
      }

      &:last-child {
        padding-top: 20px;
      }

      &:nth-child(3) {
        .column {
          .container {
            border-top: 2px solid #fff;
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
          }
        }
      }

      &:nth-child(8) {
        .column {
          .container {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: 2px solid #fff;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        }
      }
    }

    .row:nth-child(3) {
      .first-entry, .column {
        padding-top: 20px;
      }
    }

    .logo-container {
      height: 36px;
      margin-top: 10px;

      img {
        vertical-align: middle;
        max-width: 80%;
        max-height: 100%;
      }
    }

    .link {
      margin-top: 12px;
      color: #fff;
      font-size: 0.55em;
      letter-spacing: 0.1em;
      text-transform: uppercase;

      .letter-spacing {
        letter-spacing: 0.2em;
      }

      a {
        color: #fff;
      }
    }

    .button-row {
      width: calc(100% - 200px);
      margin-left: 200px;

      @media screen and (max-width: 800px) {
        margin-left: 0;
        width: 100%;
      }
    }
  }

  .mobile-only {
    display: none !important;
  }

  @media screen and (max-width: 800px) {
    .no-mobile {
      display: none !important;
    }

    .mobile-only-no-display {
      display: none !important;
    }

    .mobile-only {
      display: block !important;
    }
  }
</style>



// WEBPACK FOOTER //
// calculator.vue?ea1cba7a